<script>
  import schema from './schema';

  import { createForm } from 'svelte-forms-lib';
  import Icon from './components/Icon.svelte';

  export let setValues;
  export let setValid;

  const { form, errors, handleChange, handleSubmit, isValid, touched } =
    createForm({
      initialValues: {
        email: '',
        name: '',
        phone: '',
        message: '',
        files: null,
      },
      validationSchema: schema,
    });

  $: getClass = (value, errorClass, successClass, defaultClass = '') =>
    // eslint-disable-next-line no-nested-ternary
    $touched[value] && $errors[value]
      ? errorClass
      : $touched[value] && !$errors[value]
      ? successClass
      : defaultClass;

  function log() {
    setValues($form) &&
      setValid($isValid && $touched.name && $touched.email && $touched.phone);
  }

  $: $form && log();
</script>

<form class:valid={$isValid} on:submit|preventDefault={handleSubmit}>
  <div class="uk-margin uk-position-relative">
    <input
      class="uk-input has-floating-label {getClass(
        'name',
        'uk-form-danger',
        'uk-form-success',
      )}"
      id="name"
      name="name"
      type="text"
      on:blur={handleChange}
      on:keyup={handleChange}
      placeholder="Full name"
    />

    <label class="uk-form-label floating-label" for="name">Full name</label>

    <Icon touched={$touched} {getClass} value="name" />
  </div>

  <div class="uk-margin uk-position-relative">
    <input
      id="email"
      class="uk-input has-floating-label {getClass(
        'email',
        'uk-form-danger',
        'uk-form-success',
      )}"
      type="text"
      name="email"
      placeholder="Email"
      on:blur={handleChange}
      on:keyup={handleChange}
    />

    <label class="uk-form-label floating-label" for="email">Email</label>

    <Icon touched={$touched} {getClass} value="email" />
  </div>

  <div class="uk-margin uk-position-relative">
    <input
      class="uk-input has-floating-label {getClass(
        'phone',
        'uk-form-danger',
        'uk-form-success',
      )}"
      id="phone"
      name="phone"
      type="tel"
      placeholder="Phone"
      on:blur={handleChange}
      on:keyup={handleChange}
    />

    <label class="uk-form-label floating-label" for="phone">Phone</label>

    <Icon touched={$touched} {getClass} value="phone" />
  </div>

  <div class="uk-margin uk-position-relative">
    <textarea
      class="uk-textarea has-floating-label"
      id="message"
      name="message"
      rows="5"
      placeholder="Please provide any other relevant details (i.e. your age, height and weight, if you’re a new or existing patient, upload photos, etc)"
      on:blur={handleChange}
      on:keyup={handleChange}
    />

    <label class="uk-form-label floating-label" for="message">
      How can we help?
    </label>
  </div>

  <div class="uk-placeholder uk-text-center uk-text-small uk-margin-remove">
    <span data-uk-icon="icon: cloud-uplowad" />

    <span class="uk-text-middle">Attach binaries by dropping them here or</span>

    <div data-uk-form-custom>
      <input name="files" type="file" multiple on:change={handleChange} />
      <span class="uk-link">selecting one</span>
    </div>
  </div>
</form>
